import cn from 'classnames'
import type { MouseEventHandler } from 'react'
import { useRef, useState } from 'react'

import { MIN_COLUMN_WIDTH } from '../constants'
import type { ResizeData } from '../types'
import * as s from './Resizable.module.scss'

interface IResizableProps {
  width?: number
  onResize?: (data: ResizeData) => void
  container: HTMLDivElement | null
}

const Resizable: React.FC<IResizableProps> = ({ width, onResize, container }) => {
  const resizingRef = useRef<{
    startX: number
    startWidth: number
  } | null>(null)
  const [move, setMove] = useState(false)

  const handleMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
    resizingRef.current = {
      startX: e.clientX,
      startWidth: width ?? container?.clientWidth ?? MIN_COLUMN_WIDTH,
    }

    document.addEventListener('mousemove', handleMouseMove)
    document.addEventListener('mouseup', handleMouseUp)
  }

  const handleMouseMove = (e: MouseEvent) => {
    if (!resizingRef.current) {
      return
    }
    const delta = e.clientX - resizingRef.current.startX
    const newWidth = resizingRef.current.startWidth + delta
    document.body.style.cursor = 'col-resize'
    onResize?.({ width: newWidth, status: 'MOVE' })
    if (!move) {
      setMove(true)
    }
  }

  const handleMouseUp = (e: MouseEvent) => {
    document.removeEventListener('mousemove', handleMouseMove)
    document.removeEventListener('mouseup', handleMouseUp)
    if (resizingRef.current) {
      const delta = e.clientX - resizingRef.current.startX
      const newWidth = resizingRef.current.startWidth + delta
      document.body.style.cursor = 'default'
      onResize?.({ width: Math.max(newWidth, MIN_COLUMN_WIDTH), status: 'RELEASE' })
      setMove(false)
    }
  }

  return (
    <div className={cn(s.resizer, { [s.move]: move })} onMouseDown={handleMouseDown}>
      <span className={s.delimeter} />
    </div>
  )
}

export default Resizable
